import { TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '../ScattData.js';

class TimeSeries1DimensionalData extends TimelineSegmentContentDataBase {
  constructor(values = [], samplingRate = 1, min = 0, max = 1, bias = 0) {
    super();
    this.values = values;
    this.samplingRate = samplingRate;
    this.min = min;
    this.max = max;
    this.bias = bias;
  }

  static generateFromRawObj(timeSeries1DimensionalDataRawObj) {
    return new this(
      [ ...timeSeries1DimensionalDataRawObj['values'] ],
      timeSeries1DimensionalDataRawObj['sampling_rate'],
      timeSeries1DimensionalDataRawObj['min'],
      timeSeries1DimensionalDataRawObj['max'],
      timeSeries1DimensionalDataRawObj['bias'],
    );
  }

  generateRawObj() {
    let timeSeries1DimensionalDataRawObj = {};
    timeSeries1DimensionalDataRawObj['values'] = [ ...this.values ];
    timeSeries1DimensionalDataRawObj['sampling_rate'] = this.samplingRate;
    timeSeries1DimensionalDataRawObj['min'] = this.min;
    timeSeries1DimensionalDataRawObj['max'] = this.max;
    timeSeries1DimensionalDataRawObj['bias'] = this.bias;
    return timeSeries1DimensionalDataRawObj;
  }

  drawOnTimelineSegment({ canvas2d, rect, timeResolution }) {
    if (this.values.length === 0) return;
    let timeScale = 1000 / this.samplingRate * timeResolution;
    let valueRange = this.max - this.min;
    if (valueRange <= 0) return;
    let valueScale = rect.height / valueRange;
    canvas2d.lineWitdh = 1;
    canvas2d.strokeStyle = 'rgb(0, 0, 0)';
    canvas2d.beginPath();
    let valueXOffset = rect.x;
    let valueYOffset = rect.y + valueScale * (valueRange - (this.bias - this.min));
    let initialValueLocalX = 0;
    let initialValueLocalY = -valueScale * this.values[0];
    canvas2d.moveTo(valueXOffset + initialValueLocalX, valueYOffset + initialValueLocalY);
    for (let valueIdx = 1; valueIdx < this.values.length; ++valueIdx) {
      let valueLocalX = timeScale * valueIdx;
      let valueLocalY = -valueScale * this.values[valueIdx];
      if (valueLocalX > rect.width) {
        let previousValueLocalX = timeScale * (valueIdx - 1);
        let previousValueLocalY = -valueScale * this.values[valueIdx - 1];
        let targetLocalX = rect.width;
        let targetLocalY = previousValueLocalY + (valueLocalY - previousValueLocalY) * (targetLocalX - previousValueLocalX) / timeScale;
        canvas2d.lineTo(valueXOffset + targetLocalX, valueYOffset + targetLocalY);
        break;
      } else {
        canvas2d.lineTo(valueXOffset + valueLocalX, valueYOffset + valueLocalY);
      }
    }
    canvas2d.stroke();
  }

  clone() {
    return new this.constructor(
      [ ...this.values ],
      this.samplingRate,
      this.min,
      this.max,
      this.bias,
    );
  }

  isSameAs(that) {
    if (this.samplingRate !== that.samplingRate) return false;
    if (this.min !== that.min) return false;
    if (this.max !== that.max) return false;
    if (this.bias !== that.bias) return false;
    let numSamples = this.values.length;
    for (let sampleIdx = 0; sampleIdx < numSamples; ++sampleIdx) {
      if (this.values[sampleIdx] !== that.values[sampleIdx]) {
        return false;
      }
    }
    return true;
  }
}

class TimeSeries1DimensionalSegmentData extends TimelineSegmentDataBase {
  static contentData = TimeSeries1DimensionalData;

  constructor(begin, end, data, isLocked) {
    super(begin, end, data, isLocked);
  }

  static toString() {
    return 'TimeSeries1DimensionalSegmentData';
  }

  static get name() {
    return 'Time Series 1 Dimensional Data';
  }

  clone() {
    return new TimeSeries1DimensionalSegmentData(this.begin, this.end, this.data.clone(), false);
  }
}

export default TimeSeries1DimensionalSegmentData;
